import { DateFormatter, NumberFormatter } from "@fds/wm-typescript-formatter";
import { ConsoleLogger, Mdg2Client } from "@fds/wm-typescript-mdg2-client";
import { locale } from "./constants";
import dateFormats from "./formats/date";
import numberFormats from "./formats/number";
import Vue from "vue";

/**
 * Global DOM access to the MDG2 Client allows
 * for reuse across component distributions and
 * easy access to the client in browser console.
 */
if (typeof window !== "undefined") {
  if (!window.hasOwnProperty("mdg2client")) {
    const clientOptions = {
      flagPermissionDenied: true,
      shouldRestartSubscriptions: true
    };
    window.mdg2client = new Mdg2Client(null, clientOptions);
  }
}
/**
 * @type {Mdg2Client}
 */
const mdg2Client = window.mdg2client;
const eventBus = new Vue();
const numberFormatter = new NumberFormatter(locale);
const dateFormatter = new DateFormatter(locale);
const chartIQLatestPath = "/cdn/chart-iq/7.0.0/js/chartiq.js";

const logger = new ConsoleLogger("MDG");
const logLevel = process.env.VUE_APP_LOG_LEVEL || "silent";
logger.setLevel(ConsoleLogger.getLogLevel(logLevel));
mdg2Client.setLogger(logger);

// @ts-ignore
numberFormatter.formats.en.emptyValue = "-";
// @ts-ignore
numberFormatter.formats.de.emptyValue = "-";
numberFormatter.importFormats(numberFormats);
dateFormatter.importFormats(dateFormats);

export {
  eventBus,
  mdg2Client,
  numberFormatter,
  dateFormatter,
  locale,
  chartIQLatestPath
};
